"use client"
import React from 'react';
import QRCode from 'react-qr-code';

type QrCodeProps ={
    title?:string;
    value:string;
    fgColor?:string;
    bgColor?:string;
    size?: number
}

const QrCode = ({
                    title,
                    value,
                    size = 140,
                    fgColor = 'black',
                    bgColor = 'white'
} : QrCodeProps) => {

    return (
        <div className="flex w-full flex-col items-center py-2 ">
            <div className="flex items-center flex-col gap-2 ">
                <div className="p-1 bg-white flex items-center justify-center">
                    <QRCode
                        title={title}
                        value={value}
                        size={size}
                        bgColor={bgColor}
                        fgColor={fgColor}
                    />
                </div>
            </div>
        </div>
    );
};

export default QrCode;